import isFunction from "lodash/isFunction";
export default function addAuthorizationHeader(apiTokenOrGetApiToken) {
    return async (requestConfig) => {
        const apiToken = isFunction(apiTokenOrGetApiToken)
            ? await apiTokenOrGetApiToken()
            : apiTokenOrGetApiToken;
        return apiToken
            ? Object.assign(Object.assign({}, requestConfig), { headers: Object.assign(Object.assign({}, requestConfig.headers), { Authorization: `Bearer ${apiToken}` }) }) : requestConfig;
    };
}
//# sourceMappingURL=addAuthorizationHeader.js.map